import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { TrackingEvent } from 'webapp/enums/tracking';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class FirstBoardViewTour extends TourBase {
	@service('tour') declare tourService: Service.Tour;

	override trackEvent: TrackingEvent | '' = TrackingEvent.BUBBLE_FIRST_BOARD;

	get id(): string {
		return TourId.FIRST_BOARD_VIEW;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.DOWN,
				attachTo: () => {
					return this.el;
				},
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}

	override end(): void {
		super.end();
		this.tourService.isEligibleForFirstBoardViewTour = false;
	}
}
